import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { NormaService } from '../services/norma.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import * as Datepicker from 'js-datepicker';
import { UploaderService } from '../services/uploader.service';
@Component({
  selector: 'app-norma-edit',
  templateUrl: './norma-edit.component.html',
  styleUrls: ['./norma-edit.component.css'],
  animations: [loadingFade]
})
export class NormaEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public norma_id = null;

  public formNorma: FormGroup;

  public file;
  public file_name;
  public file_name_upload;

  public norma_data_dp;

  constructor(private authSvc: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private normaSvc: NormaService,
    private uploaderSvc: UploaderService,
  ) { }

  ngOnInit() {
    this.criaForm();
    this.loading = true;

    this.route.params.subscribe(params => {
      if (params.id) {
        this.norma_id = params.id;
        this.normaSvc.getNorma(params.id).then((data: any) => {
          this.preencheForm({
            norma_id: null,
            norma_nome: data.norma_nome,
            norma_data: moment(data.norma_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            norma_descricao: data.norma_descricao,
            norma_arquivo: null
          });
          this.file_name = data.norma_arquivo_nome;
          this.loading = false;
        });
      }
      else {
        this.loading = false;
      }
    });
  }


  criaForm() {
    this.formNorma = this.fb.group({
      norma_id: null,
      norma_nome: ['', [Validators.required]],
      norma_descricao: ['', [Validators.required]],
      norma_data: ['', [Validators.required]],
      norma_arquivo: [null, [Validators.required]]
    });

    moment.locale('pt-Br');
    this.norma_data_dp = Datepicker('#norma_data', {
      customMonths: moment.months(),
      customDays: moment.weekdaysShort(),
      overlayPlaceholder: 'Preencha o ano',
      overlayButton: 'Enviar',
      formatter: (element, date) => {
        let formatted = moment(date).format('DD/MM/YYYY');
        this.formNorma.controls['norma_data'].setValue(formatted);
      }
    });
  }

  preencheForm(dados) {
    this.formNorma.setValue(dados);
  }

  enviaNorma() {
    if (this.formNorma.valid) {
      this.submitting = true;

      let toSend = this.formNorma.value;

      if (this.file.length > 0) {

        let formData = new FormData();
        formData.append("file", this.file[0], this.file_name_upload);
        if(this.file[0].size < 15000000){
          this.uploaderSvc.sendFile(formData).then((data) => {
            toSend.norma_arquivo = this.file_name_upload != null ? this.file_name_upload : '';
            toSend.norma_arquivo_nome = this.file_name != null ? this.file_name : '';
  
            if (this.norma_id === null) { // criar
              this.normaSvc.criaNorma(toSend).then((data) => {
                console.log('resp', data);
                Swal.fire({
                  type: 'success',
                  title: 'Norma cadastrado com sucesso!',
                  onClose: () => {
                    this.router.navigate(['home/norma']);
                  }
                });
              }).catch(err => {
                console.log(err);
                this.submitting = false;
                Swal.fire({
                  type: 'error',
                  title: 'Ops! Algo de errado aconteceu!',
                  text: 'Tente novamente mais tarde.'
                });
              });
            }
            else { // editar
              toSend.norma_id = this.norma_id;
              this.normaSvc.editaNorma(toSend).then((data) => {
                console.log('resp', data);
                Swal.fire({
                  type: 'success',
                  title: 'Norma cadastrado com sucesso!',
                  onClose: () => {
                    this.router.navigate(['home/norma']);
                  }
                });
              }).catch(err => {
                console.log(err);
                this.submitting = false;
                Swal.fire({
                  type: 'error',
                  title: 'Ops! Algo de errado aconteceu!',
                  text: 'Tente novamente mais tarde.'
                });
              });
            }
          }).catch((err) =>{
            this.submitting = false;
            Swal.fire({
              type: 'error',
              title: 'Ops! Algo de errado aconteceu!',
              text: 'Formato de arquivo inválido.'
            });
          });
        }
        else{
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tamanho de arquivo inválido.'
          });
        }
      }
    }
    else {
      for (let field in this.formNorma.controls) {
        let campo = this.formNorma.get(field);
        campo.markAsTouched();
      }
      Swal.fire({
        type: 'error',
        title: 'Atenção!',
        text: 'Verifique os campos obrigatórios e tente novamente.'
      });
    }
  }

  invalid(nome) {
    let input = this.formNorma.get(nome);
    return input.touched && input.invalid;
  }

  onNormaSelect(e) {
    this.file = <File>e.target.files;
    this.file_name = this.file[0].name;
    this.file_name_upload = this.file[0].name.split('.');
    this.file_name_upload = this.file_name_upload[0] + moment().format('x') + '.' + this.file_name_upload[1];
  }
}
